

export enum AnalysisWizardStepType {

    InputData = "Input Data",
    DataProcessing = "Data Processing",
    AnalysisConfiguration = "Analysis Config",
    CustomCalculations = "Custom Calculations",
    PostProcessing = "Post Processing",
    Reports = "Reports"

}